export default new (class {
  constructor() {
    this.animations = [];
    this.animate();
    this.removed = [];

    this.easing = {
      linear: t => t,
      cubic: t => t * t * (3 - 2 * t)
    };
  }

  animate() {
    requestAnimationFrame(() => this.animate());
    const now = +new Date();
    const animations = this.animations;
    this.animations = [];
    const removed = new Set(this.removed);
    this.removed = [];
    this.animations.push(
      ...animations.filter(animation => {
        if (removed.has(animation.action)) return false;

        const {
          last,
          start,
          action,
          options: {
            min,
            max,
            length,
            ease,
            onEnd,
            key,
            repeat,
            flip,
            stepLength
          }
        } = animation;
        if (now - last < stepLength) return true;
        let t = (now - start) / length;
        animation.last = now;
        if (t > 1) t = 1;
        else if (t < 0) t = 0;
        const v = min + ease(t) * (max - min);
        if (key) {
          action.setState({ [key]: v });
        } else {
          action(v);
        }
        if (t >= 1) {
          if (onEnd) onEnd();
          if (repeat) {
            animation.start = now;
            if (flip)
              [animation.options.min, animation.options.max] = [max, min];
            return true;
          } else {
            return false;
          }
        }
        return true;
      })
    );
  }

  remove(actionToRemove) {
    this.removed.push(actionToRemove);
  }

  add(action, options) {
    options = {
      ease: t => t,
      min: 0,
      max: 1,
      length: 5000,
      key: null,
      stepLength: 0,
      ...options
    };
    this.animations.push({
      start: +new Date(),
      last: 0,
      action,
      options
    });
  }
})();
